module.exports = __webpack_public_path__ + "img/pic_feature_04.3bb73f52.jpg";